import { gql } from '@apollo/client';
import MASTERCODE_FRAGMENT from 'graph/fragments/mastercodes';

const TRANSFER_MASTERCODE = gql`
  mutation transferMastercode(
    $mastercodeId: Int!
    $ownerEmail: String!
    $data: MastercodeTransferInput!
  ) {
    transferMastercode(where: { id: $mastercodeId, ownerEmail: $ownerEmail }, data: $data) {
      ...MastercodeFragment
    }
  }
  ${MASTERCODE_FRAGMENT}
`;

export default TRANSFER_MASTERCODE;
